import classNames from 'classnames';
import React, { useContext } from 'react';
import { ProHeaderAttrField, ProTextField } from '../../../atoms/AttrField/AttrField';
import { ProDropdown } from '../../../atoms/AttrField/Dropdown';
import { ProNumberField } from '../../../atoms/AttrField/NumberField';
import { ProCol } from '../../../atoms/Grid/Col';
import { ProRow } from '../../../atoms/Grid/Row';
import { ProIconData } from '../../../atoms/Icons/IconData';
import { WindowButtonsForMode } from '../../../atoms/WindowButtonsForMode/WindowButtonsForMode';
import { ProDetailWindow } from '../../../components/DetailWindow/DetailWindow';
import { ApplicationElementType, getBaseBCItemForType } from '../../../components/DetailWindow/breadCrump.helpers';
import { UserContext } from '../../../contexts/UserContext';
import { Components } from '../../../utils/types';
import { DetailWindowProps } from '../GenericDetailWindow';
import { getWindowDisplayStateMode } from '../WBSElement/WBSElement.helpers';

export const CostFunctionDetailWindow = ({
    cancelChanges,
    closeAction,
    isDisabled,
    isDisplayed,
    loading,
    mode,
    saveAction,
    setFormData,
    setMode,
    createAction,
    deleteAction,
    error,
    formData,
    t,
}: DetailWindowProps<Components.Schemas.CostFunctionRoleDTO>) => {
    const { portfolioPersonUnits, portfolio } = useContext(UserContext);
    const { costFunctionCriteriaOrigins } = portfolio ?? {};
    return (
        <ProDetailWindow
            title={
                isDisabled ? (
                    <h2
                        className={classNames(
                            formData?.name?.length &&
                                formData?.name?.length >= 180 &&
                                'ProDetailWindow--header--title__large'
                        )}
                    >
                        {formData?.name ?? t('windows.details')}
                    </h2>
                ) : (
                    <ProHeaderAttrField
                        name={t('windows.name')}
                        value={formData?.name ?? String(t('windows.details'))}
                        disabled={false}
                        handleChange={(input) =>
                            setFormData((old) => ({ ...old, name: String(input).substring(0, 180) }))
                        }
                    />
                )
            }
            breadCrump={getBaseBCItemForType([ApplicationElementType.People], t)}
            displayState={isDisplayed}
            icon={ProIconData.person_fill}
            buttonSection={
                <WindowButtonsForMode
                    cancelAction={cancelChanges}
                    closeAction={closeAction}
                    createAction={createAction}
                    deleteAction={deleteAction}
                    saveAction={saveAction}
                    setMode={setMode}
                    mode={mode}
                    t={t}
                />
            }
            error={error}
            loading={loading}
            intent={getWindowDisplayStateMode(mode)}
        >
            <ProRow>
                <ProCol span={3}>
                    <ProNumberField
                        name={t('windows.pricePerUnit')}
                        disabled={isDisabled}
                        value={formData?.price}
                        handleChange={(value) => setFormData((cur) => ({ ...cur, price: Number(value) }))}
                        entity="€"
                    />
                </ProCol>
                <ProCol span={3}>
                    <ProDropdown
                        name={t('windows.unit')}
                        disabled={isDisabled}
                        value={formData?.priceUnit?.name}
                        items={portfolioPersonUnits?.map((cur) => cur.name ?? '-')}
                        setValue={(value) =>
                            setFormData((cur) => ({
                                ...cur,
                                priceUnit: portfolioPersonUnits?.find((cur) => cur.name === value),
                            }))
                        }
                    />
                </ProCol>
                <ProCol span={3}>
                    <ProDropdown
                        name={t('windows.origin')}
                        disabled={isDisabled}
                        value={formData?.origin?.name}
                        items={costFunctionCriteriaOrigins?.map((cur) => cur.name ?? '-')}
                        setValue={(value) =>
                            setFormData((cur) => ({
                                ...cur,
                                origin: costFunctionCriteriaOrigins?.find((cur) => cur.name === value),
                            }))
                        }
                    />
                </ProCol>
                <ProCol span={3}>
                    <ProDropdown
                        name={t('windows.level')}
                        disabled={isDisabled}
                        value={formData?.level?.name}
                        items={portfolio?.costFunctionCriteriaLevels?.map((cur) => cur.name ?? 'not named')}
                        setValue={(value) =>
                            setFormData((cur) => ({
                                ...cur,
                                level: portfolio?.costFunctionCriteriaLevels?.find((cur) => cur.name === value),
                            }))
                        }
                    />
                </ProCol>
            </ProRow>
            <ProRow>
                <ProCol span={12}>
                    <ProTextField
                        name={t('windows.description')}
                        disabled={isDisabled}
                        value={formData?.description}
                        handleChange={(value) => setFormData((cur) => ({ ...cur, description: String(value) }))}
                    />
                </ProCol>
            </ProRow>
        </ProDetailWindow>
    );
};
